// extracted by mini-css-extract-plugin
export default {"header":"App_header__45F9h","link":"App_link__6mT5b","button":"App_button__vTRg6","subLink":"App_subLink__BCAnT","dropdownFooter":"App_dropdownFooter__X+v1U"};